import React from 'react';

export function Modal ({assetUrl, assetType, onClose, showing}) {
    console.log(assetUrl, assetType, 'asset url');
    const renderContent = () => {
        switch (assetType) {
            case "Image":
                return <img src={assetUrl} style="width:100%;"/>
            case "Video":
                return (
                    <video controls autoPlay>
                        <source src={assetUrl} type="video/mp4"/>
                        Your browser does not support the video tag.
                    </video>
                )
            case "Audio":
                return (
                    <audio controls autoPlay>
                        <source
                            src={assetUrl}
                            type="audio/mp3"/>
                        Your browser does not support the audio tag.
                    </audio>
                )
            default:
                return <p>No asset type</p>
        }
    }

    if (!showing) return null;

    return (
        <div className="ah-modal-overlay">
            <div className="ah-modal-content">
                <button className="close-button" onClick={onClose}>Go back</button>
                {renderContent()}
            </div>
        </div>
    );
}
